import axios from 'axios';

import {
  reducerGetFiltersSignals,
  reducerGetSignals,
  reducerSignalsStatus,
} from '../../reducer/tunder/reducers/reducerSignals';
import { AppDispatch } from '../../reducer/store';
import { getToken } from '../axiosToken';

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const actionGetSignals =
  (limit: number, offset: number) =>
  async (dispatch: AppDispatch, getState: () => any) => {
    const { token } = await getToken();
    axios.defaults.headers.common['Authorization'] = token;

    const store = getState();
    const { signalsInputValues } = store.tunder.signals;

    try {
      const response = await axios.post(`${BASE_URL}/json/tander/signal/list`, {
        address:
          signalsInputValues?.address.length > 0
            ? signalsInputValues?.address
            : null,
        contract: signalsInputValues?.contract,
        employee: signalsInputValues?.employee,
        endDate: signalsInputValues?.toDate,
        limit,
        page: offset / limit + 1,
        product:
          signalsInputValues?.product.length > 0
            ? signalsInputValues?.product
            : null,
        productCode: signalsInputValues?.productCode,
        shopCode: signalsInputValues?.shopCode
          ? [signalsInputValues?.shopCode]
          : [],
        startDate: signalsInputValues?.fromDate,
      });
      dispatch(reducerGetSignals({ data: response.data, limit, offset }));
    } catch {
      console.log('err');
    }
  };

export const actionGetFiltersSignals = () => async (dispatch: AppDispatch) => {
  const { token } = await getToken();
  axios.defaults.headers.common['Authorization'] = token;

  try {
    const response = await axios.get(`${BASE_URL}/json/tander/signal/form`);
    dispatch(reducerGetFiltersSignals({ data: response.data }));
  } catch {
    console.log('err');
  }
};

export const actionExportSignals =
  () => async (dispatch: AppDispatch, getState: () => any) => {
    try {
      const { token } = await getToken();
      const headers = {
        Authorization: token,
      };

      const store = getState();
      const { signalsInputValues } = store.tunder.signals;

      await axios.get(
        `${BASE_URL}/json/tander/export/signals`,
        {
          headers,
          params: {
            startDate: signalsInputValues?.fromDate,
            endDate: signalsInputValues?.toDate,
          }
          
        },
      );
      dispatch(reducerSignalsStatus(205));
    } catch (error) {
      dispatch(reducerSignalsStatus(0));
    }
  };
